import { render, staticRenderFns } from "./RecordSettings.vue?vue&type=template&id=24c5a891&scoped=true"
import script from "./RecordSettings.vue?vue&type=script&lang=js"
export * from "./RecordSettings.vue?vue&type=script&lang=js"
import style0 from "./RecordSettings.vue?vue&type=style&index=0&id=24c5a891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5a891",
  null
  
)

export default component.exports